const f = {
  color: {
    variant: {
      charcoal: {
        background: "#f1f3f5ff",
        text: "#7e8e9eff"
      },
      blue: {
        background: "#d1e8ffff",
        text: "#304ddbff"
      },
      green: {
        background: "#e0fcdeff",
        text: "#2d8556ff"
      },
      purple: {
        background: "#f2e5ffff",
        text: "#774ba3ff"
      },
      yellow: {
        background: "#ffeeccff",
        text: "#ac771bff"
      },
      red: {
        background: "#fedfd5ff",
        text: "#b83525ff"
      },
      cobalt: {
        background: "#d1e8ffff",
        text: "#304ddbff"
      },
      info: {
        background: "#4176faff",
        text: "white"
      },
      clay: {
        background: "#f5f2f0ff",
        text: "#9e8f88ff"
      },
      orange: {
        background: "#ffe4d1ff",
        text: "#a35214ff"
      },
      white: {
        background: "white",
        text: "#314351ff"
      },
      magenta: {
        background: "#ffe5eaff",
        text: "#a34b6bff"
      }
    }
  }
};
export {
  f as squircle
};
